let lastWsMessageAt: number | null = null;

export const recordWsMessage = (): void => {
  lastWsMessageAt = Date.now();
};

export const getLastWsMessageAt = (): number | null => lastWsMessageAt;
